export const PERMISSION_CATALOG = [
  {
    slug: 'view_contact_details',
    name: 'View Contact Details',
    defaultLimit: 5,
    defaultPeriod: 'total'
  },
  {
    slug: 'chat_messages',
    name: 'Unlimited Chat',
    defaultLimit: null,
    defaultPeriod: 'total'
  },
  {
    slug: 'office_assisted_profiles',
    name: 'Office Assisted Profiles',
    defaultLimit: 0,
    defaultPeriod: 'total'
  }
];

export const PERMISSION_LOOKUP = PERMISSION_CATALOG.reduce((acc, permission) => {
  acc[permission.slug] = permission;
  return acc;
}, {});